import loadable from '@loadable/component'
import {getRouter} from 'hiya-common/src/routes'
import game from './game'
import wallet2 from './wallet2'
import wallet from './wallet'
import hunting from './hunting'
import feedback from './feedback'
import anchorcenter from './anchorcenter'
import coinagency from './coinagency'
import union from './union'
import loginQuestion from './loginQuestion'
import lord from './lord'
import svip from './svip'
import guildSettled from './guildSettled'
import Helping from './Helping'
import salary from './salary'
import bdCenter from './bdCenter'
import cpSpace from './cpSpace'
import roomEntrance from './roomEntrance'

const routes = getRouter([
  ...game,
  ...wallet2,
  ...salary,
  ...wallet,
  ...hunting,
  ...feedback,
  ...anchorcenter,
  ...union,
  ...coinagency,
  ...loginQuestion,
  ...lord,
  ...svip,
  ...guildSettled,
  ...Helping,
  ...bdCenter,
  ...cpSpace,
  ...roomEntrance,
  {
    // 房间等级
    path: '/RoomLevel',
    exact: true,
    component: loadable(
      () => import(/* webpackChunkName: "page-RoomLevel" */ '~/pages/RoomLevel')
    ),
  },
  {
    // 勋章墙
    path: '/MedalWall',
    exact: true,
    component: loadable(
      () => import(/* webpackChunkName: "page-MedalWall" */ '~/pages/MedalWall')
    ),
  },
  {
    // 财务等级魅力等级
    path: '/UserWealthLevel',
    exact: true,
    component: loadable(
      () => import(/* webpackChunkName: "page-UserLevel" */ '~/pages/UserLevel')
    ),
  },
  {
    // 首页排行榜
    path: '/CoreRanking',
    exact: true,
    component: loadable(
      () =>
        import(/* webpackChunkName: "page-CoreRanking" */ '~/pages/CoreRanking')
    ),
  },
  {
    path: '/FirstCharge/RechargeChannel',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-FirstCharge-RechargeChannel" */ '~/pages/FirstCharge/RechargeChannel'
        )
    ),
  },
  {
    path: '/FirstCharge',
    exact: true,
    component: loadable(
      () =>
        import(/* webpackChunkName: "page-FirstCharge" */ '~/pages/FirstCharge')
    ),
  },
  {
    path: '/FirstCharge/Repurchase',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-FirstCharge-Repurchase" */ '~/pages/FirstCharge/Repurchase'
        )
    ),
  },
  {
    path: '/UserInfoCollection',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-UserInfoCollection" */ '~/pages/UserInfoCollection'
        )
    ),
  },
  {
    path: '/LuckyGift/jackpot',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-LuckyGift-jackpot" */ '~/pages/LuckyGift/Jackpot'
        )
    ),
  },
  {
    path: '/send',
    exact: true,
    component: loadable(
      () => import(/* webpackChunkName: "page-Send" */ '~/pages/Send')
    ),
  },
  {
    path: '/ShareFriends',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-ShareFriends" */ '~/pages/ShareFriends'
        )
    ),
  },
  {
    // 迎新礼包下发
    path: '/WelcomePack',
    exact: true,
    component: loadable(
      () =>
        import(/* webpackChunkName: "page-WelcomePack" */ '~/pages/WelcomePack')
    ),
  },
  {
    // 管理库存
    path: '/WelcomePack/ManagePack/:type/:name/:id',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-WelcomePack-ManagePack" */ '~/pages/WelcomePack/ManagePack'
        )
    ),
  },
  {
    // 用户等级提升
    path: '/UserLevel',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-UserLevel" */ '~/pages/WelcomePack/UserLevel'
        )
    ),
  },
  {
    // ios app下载页
    path: '/IosDownload',
    exact: true,
    component: loadable(
      () =>
        import(/* webpackChunkName: "page-IosDownload" */ '~/pages/IosDownload')
    ),
  },
  {
    // 新用户承接任务
    path: '/newUserTask',
    exact: true,
    component: loadable(
      () => import(/* webpackChunkName: "page-newUserTask" */ '~/pages/NewUser')
    ),
  },
  {
    // 新用户承接任务记录
    path: '/newUserTask/record',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-newUserTask-record" */ '~/pages/NewUser/Record'
        )
    ),
  },
  {
    // pk规则
    path: '/pk/rule',
    exact: true,
    component: loadable(
      () =>
        import(/* webpackChunkName: "page-pk-rule" */ '~/pages/Pk/pages/Rule')
    ),
  },
  {
    // pk榜单
    path: '/pk/rank',
    exact: true,
    component: loadable(
      () =>
        import(/* webpackChunkName: "page-pk-rank" */ '~/pages/Pk/pages/Rank')
    ),
  },
])

export default (store) => routes

// export default (store) => getRouter([...anchorcenter])
